import { canAccess } from '@/utils/acl';

const state = () => ({
  categories: {},
});

const getters = {
  all: (state, getters, rootState, rootGetters) => {
    const categories = Object.keys(state.categories).map(id => state.categories[id]);
    const access = {};

    categories.forEach(c => {
      access[c.id] = canAccess(rootGetters['session/currentUser'], c);
    });

    categories.sort((a, b) => {
      const accessA = access[a.id];
      const accessB = access[b.id];
      if (accessA && !accessB) return -1;
      if (!accessA && accessB) return 1;
      return a.number - b.number;
    });

    return categories;
  },
  categories: state => state.categories,
  leaves: (state, getters) => getters['all'].filter(c => c.children.length === 0),
  root: (state, getters) => getters['all'].filter(c => !c.parentCategoryId),
  type: (state, getters) => {
    const obj = {};
    getters.root.map(c => {
      if (obj[c.categoryTypeId]) {
        obj[c.categoryTypeId].push(c.id);
      } else {
        obj[c.categoryTypeId] = [c.id];
      }
    });

    return obj;
  },
};

const mutations = {
  setCategories: function(state, categories) {
    for(let category of categories) {
      state.categories[category.id] = Object.freeze(category);
    }
  },
  deleteCategory: function(state, categoryId) {
    const category = state.categories[categoryId];
    console.log(category);
    if (category && category.userId) {
      delete state.categories[categoryId];
    }
  },
  reset(state) {
    state.categories = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
